import { useContext } from "react";
import { GlobalContext } from "../App";
import { useIP } from "../hooks/useIP";
import { useTranslation } from "../i18n";
import Jump from "./Jump";

const OperationGuide = function () {
  const { language } = useContext(GlobalContext);
  const { t } = useTranslation();
  const ip = useIP();

  const renderActiveText = (text: string) => {
    return text.replace(/(help@dodoex\.io)/, "<span class='active'>$1</span>");
  };

  return (
    <div>
      <h2>{t("operation.guide")}</h2>
      <h3
        dangerouslySetInnerHTML={{ __html: renderActiveText(t("scenes.1")) }}
      ></h3>
      <h4>
        {t("ip")}: {ip}
      </h4>
      <h4 style={{ marginBottom: 7 }}>
        {t("ipAndDns")}:
        <Jump url="http://nstool.netease.com/" />
      </h4>
      <h4 className={language === "zh-CN" ? "" : "connect"}>
        {t("connect.dodo.instance.ip")}:
        <Jump
          style={{ marginLeft: language === "zh-CN" ? 20 : 9 }}
          url="http://119.29.29.29/d?dn=app.dodoex.io"
        />
      </h4>
      <h3
        className="second"
        dangerouslySetInnerHTML={{ __html: renderActiveText(t("scenes.2")) }}
      ></h3>
    </div>
  );
};

export default OperationGuide;
